/**
 * BoxWithBackgroundCard component
 * @returns <BoxWithBackgroundCard />
 */
import { NavLink } from "react-router-dom";
import Badge from "./Badge";
import { mock } from "../mock/data";

const getIconType = (item) => (item.price_discount ? "discount" : item.type);

const BoxWithBackgroundCard = ({ item }) => {
    const { iconSources } = mock;
    return (
        <NavLink to={item.url}>
            <div
                className={`box-with-background_container_card store-width ${
                    item.type === "maintenance" ? "--mantencion" : ""
                } ${
                    item.type === "accessory" ? "--accessory" : ""
                } ${
                    item.type === "merchandise" ? "--merchandise" : ""
                } ${
                    item.stock === 0 ? "--out-of-stock" : ""
                } ${
                    item.dark_background || item.price_discount ? "--dark-background" : ""
                }`}
            >
                <span className="box-with-background_container_card-top">
                    {item.type !== "vehicle" && (
                        <img
                            src={iconSources[getIconType(item)]}
                            alt=""
                            className="box-with-background_container_card-top_icon"
                        />
                    )}

                    <span
                        className="box-with-background_container_card-top_text"
                        style={{ marginLeft: item.icon ? "0px" : "" }}
                    >
                        <span className="left">
                            <p className="box-with-background_card-title --text-m">
                                <strong>{item.title}</strong>
                            </p>
                            <p className="box-with-background_card-subtitle box-with-background_card-subtitle--service --text-s fw-300">
                                {item.subtitle}
                            </p>
                            {item.price_discount && (
                                <p className="box-with-background_card-subtitle box-with-background_card-subtitle--list-price --text-s">
                                    Precio de lista desde:
                                </p>
                            )}
                        </span>

                        <span className="right">
                            <p className="box-with-background_card-price --text-m">
                                {item.currency === "USD" ? "U$D" : "$"}{" "}
                                {item.price_discount ? item.price_discount : item.price}
                            </p>
                            {item.price_discount && (
                                <p className="box-with-background_card-price_discount --text-s">
                                    {item.currency === "USD" ? "U$D" : "$"}{" "}
                                    {item.price}
                                </p>
                            )}
                            {(item.type === "vehicle" ||
                                item.type === "modelo") && (
                                <p className="box-with-background_card-green-tax --text-s">
                                    + I.V. {item.green_tax}
                                </p>
                            )}

                            {item.km && (
                                <p className="box-with-background_card-km --text-s">
                                    {item.km}
                                </p>
                            )}
                        </span>
                    </span>
                </span>

                <img
                    src={item.image}
                    alt={item.title}
                    className="box-with-background_container_card-top_img"
                />

                {item.stock ? (
                    item.stock_warning ? (
                        <Badge
                            type="badge-card"
                            text="¡Último disponible!"
                            backgroundColor="#AD0B00"
                        />
                    ) : (
                        <Badge
                            type="badge-card"
                            text={`${item.stock} disponibles`}
                            backgroundColor="#8A8D8F"
                        />
                    )
                ) : null}

                {item.price_discount ? (
                    <Badge
                        type="badge-card"
                        text={`Descuento Online`}
                        backgroundColor="#AD0B00"
                    /> 
                ) : null}
            </div>
        </NavLink>
    );
};

export default BoxWithBackgroundCard;
